export default __webpack_public_path__ + "assets/images/5f0668821642c86b97131d10d5b09399.png";